/**
 * Constantes y helpers puros del report de Eficacia. No tocan estado
 * de React — sólo cálculos y configuración compartida.
 */

// Sin paginación: enviamos un límite alto y mostramos todas las filas.
// Si algún día llegamos a >5000 familias por temporada (improbable),
// habrá que volver a paginar o virtualizar.
export const PAGE_LIMIT = 5000;

// Opciones del switch Temporada (los valores son los que entiende el back).
export const SEASON_OPTIONS = [
  { label: 'Verano', value: 'VERANO' },
  { label: 'Invierno', value: 'INVIERNO' },
];

// Dimensiones por las que se puede filtrar (bundle = aparecen agrupadas
// dentro del segmented). Los valores se hidratan desde el back con
// `hydrateFilters`.
export const BASE_FILTERS = {
  genders: { name: 'Género', slug: 'genders', bundle: true },
  categories: { name: 'Categorías', slug: 'categories', bundle: true },
  subcategories: { name: 'Subcategorías', slug: 'subcategories', bundle: true },
};

// Última campaña iniciada según la fecha del usuario:
//   Mar–Ago → VERANO año actual
//   Sep–Dic → INVIERNO año actual
//   Ene–Feb → INVIERNO año anterior
export const getCurrentCampaign = () => {
  const now = new Date();
  const m = now.getMonth() + 1;
  const y = now.getFullYear();
  if (m >= 3 && m <= 8) return { season: 'VERANO', year: String(y) };
  if (m >= 9) return { season: 'INVIERNO', year: String(y) };
  return { season: 'INVIERNO', year: String(y - 1) };
};

// Opciones del switch Año: el año siguiente al actual + 5 anteriores.
// Suficiente rango para revisar campañas pasadas sin saturar el menu.
export const buildYearOptions = () => {
  const now = new Date().getFullYear();
  const years = [];
  for (let y = now + 1; y >= now - 5; y -= 1) years.push({ label: String(y), value: String(y) });
  return years;
};

// Cierre de una temporada según el calendario del negocio:
//   VERANO Y    → 31 ago Y
//   INVIERNO Y  → último día de febrero Y+1 (28 ó 29 en bisiesto)
// Truco: `new Date(y, 2, 0)` = día 0 de marzo = último día de febrero
// (el mes 2 es marzo, day=0 cae al día anterior, manejando bisiestos).
export const endOfSeason = (season, year) => {
  const y = Number(year);
  if (season === 'VERANO') return new Date(y, 7, 31, 23, 59, 59);
  return new Date(y + 1, 2, 0, 23, 59, 59);
};

// Días enteros (redondeo al alza) desde hoy hasta `date`. Negativo si
// la fecha ya pasó.
export const daysUntil = (date) => {
  const diff = date.getTime() - Date.now();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};
